export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
};

export type Query = {
  __typename?: 'Query';
  getFeatureFlags?: Maybe<FeatureFlagResponse>;
  RH_getConversationById: Rh_Conversation;
  RH_getDocumentUploadToken?: Maybe<Scalars['String']['output']>;
  RH_getHotpadsUser: User;
  RH_getLatestConversations: Rh_ConversationResponse;
  RH_getSyndicationUrls?: Maybe<Rh_SyndicationUrls>;
  RH_getTruliaUser: User;
  RH_getZdocIdsForMessageTokens: Array<Scalars['String']['output']>;
  RH_getZillowUser: User;
  ZRM_getAbTestVersions: Zrm_AbTestVersionsResponse;
  ZRM_getAggregateConversationCount?: Maybe<Zrm_AggregateConversationCount>;
  ZRM_getAttachmentsByConversationId: Zrm_GetAttachmentsByConversationIdResponse;
  ZRM_getConnectedExperience: Zrm_ConnectedExperience;
  ZRM_getConversationById: Zrm_Conversation;
  ZRM_getConversationCountsForListings?: Maybe<Array<Maybe<Zrm_ListingStats>>>;
  ZRM_getConversationInformationByInquiryId: ConversationInformation;
  ZRM_getConversationSearchResult: Zrm_GetConversationSearchResultResponse;
  ZRM_getDocumentUploadToken?: Maybe<Scalars['String']['output']>;
  ZRM_getExperimentTreatment: Zrm_GetExperimentTreatmentResponse;
  /** @deprecated Use ZRM_getListingPerformance */
  ZRM_getFunnelReportV2: Zrm_GetFunnelReportV2Response;
  ZRM_getLatestConversationsV2: Zrm_ConversationResponse;
  ZRM_getLeadManagementCounts: Zrm_GetLeadManagementCountsResponse;
  ZRM_getLeadManagementLeads: Zrm_GetLeadManagementLeadsResponse;
  ZRM_getLeadManagementSearchResult: Zrm_GetLeadManagementSearchResultResponse;
  ZRM_getLeadManagementStats: Zrm_GetLeadManagementStatsResponse;
  ZRM_getListingPerformance: Zrm_GetListingPerformanceResponse;
  ZRM_getPropertiesList: Zrm_GetPropertiesListResponse;
  ZRM_getPropertyAddress: Zrm_GetPropertyAddressResponse;
  ZRM_getPropertySearchResult: Zrm_GetPropertySearchResultResponse;
  ZRM_getPropertyWebAnalytics: Zrm_GetPropertyWebAnalyticsResponse;
  ZRM_getSavedReplies: Zrm_GetOrAddSavedRepliesResponse;
  ZRM_getUser: User;
  ZRM_getZdocIdsForMessageTokens: Array<Scalars['String']['output']>;
};

export type QueryGetFeatureFlagsArgs = {
  appName: Scalars['String']['input'];
};

export type QueryRh_GetConversationByIdArgs = {
  conversationId: Scalars['String']['input'];
  includeAttachmentsMetadata?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  paginationStartIndex?: InputMaybe<Scalars['String']['input']>;
  startIndex?: InputMaybe<Scalars['String']['input']>;
};

export type QueryRh_GetLatestConversationsArgs = {
  archivedOnly?: InputMaybe<Scalars['Boolean']['input']>;
  daysBack?: InputMaybe<Scalars['Int']['input']>;
  folder?: InputMaybe<Folder>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  notRepliedToOnly?: InputMaybe<Scalars['Boolean']['input']>;
  paginationStartIndex?: InputMaybe<Scalars['String']['input']>;
  spamOnly?: InputMaybe<Scalars['Boolean']['input']>;
  startIndex?: InputMaybe<Scalars['String']['input']>;
  unreadOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryRh_GetSyndicationUrlsArgs = {
  listingAlias: Scalars['String']['input'];
};

export type QueryRh_GetZdocIdsForMessageTokensArgs = {
  messageTokens: Array<Scalars['String']['input']>;
};

export type QueryZrm_GetAbTestVersionsArgs = {
  enrollInExperiment?: InputMaybe<Scalars['Boolean']['input']>;
  experimentPercent?: InputMaybe<Scalars['Int']['input']>;
  tests: Scalars['String']['input'];
};

export type QueryZrm_GetAttachmentsByConversationIdArgs = {
  conversationId: Scalars['String']['input'];
};

export type QueryZrm_GetConnectedExperienceArgs = {
  propertyId: Scalars['String']['input'];
};

export type QueryZrm_GetConversationByIdArgs = {
  clientTimeZone?: InputMaybe<Scalars['String']['input']>;
  conversationId: Scalars['String']['input'];
  includeAttachmentsMetadata?: InputMaybe<Scalars['Boolean']['input']>;
  includeInquiryInfo?: InputMaybe<Scalars['Boolean']['input']>;
  includeRenterProfile?: InputMaybe<Scalars['Boolean']['input']>;
  includeStatusLabels?: InputMaybe<Scalars['Boolean']['input']>;
  includeSystemMessages?: InputMaybe<Scalars['Boolean']['input']>;
  includeUserLeadAttributes?: InputMaybe<Scalars['Boolean']['input']>;
  listingAlias?: InputMaybe<Scalars['String']['input']>;
  listingId?: InputMaybe<Scalars['String']['input']>;
  paginationStartIndex?: InputMaybe<Scalars['String']['input']>;
  startIndex?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryZrm_GetConversationInformationByInquiryIdArgs = {
  inquiryId: Scalars['String']['input'];
};

export type QueryZrm_GetConversationSearchResultArgs = {
  endTimestampMs: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
  listingAlias?: InputMaybe<Scalars['String']['input']>;
  offset: Scalars['Int']['input'];
  searchText: Scalars['String']['input'];
  startTimestampMs: Scalars['String']['input'];
};

export type QueryZrm_GetExperimentTreatmentArgs = {
  featureName: Scalars['String']['input'];
  listingAlias?: InputMaybe<Scalars['String']['input']>;
};

export type QueryZrm_GetFunnelReportV2Args = {
  endDayYyyyMmDd: Scalars['String']['input'];
  includeMarketInsights?: InputMaybe<Scalars['Boolean']['input']>;
  listingAlias?: InputMaybe<Scalars['String']['input']>;
  startDayYyyyMmDd: Scalars['String']['input'];
};

export type QueryZrm_GetLatestConversationsV2Args = {
  clientTimeZone?: InputMaybe<Scalars['String']['input']>;
  conversationId?: InputMaybe<Scalars['String']['input']>;
  daysBack?: InputMaybe<Scalars['Int']['input']>;
  endDateYyyyMmDd?: InputMaybe<Scalars['String']['input']>;
  excludeNote?: InputMaybe<Scalars['Boolean']['input']>;
  folder?: InputMaybe<Folder>;
  includeRenterProfile?: InputMaybe<Scalars['Boolean']['input']>;
  includeStatusLabels?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  listingAlias?: InputMaybe<Scalars['String']['input']>;
  listingId?: InputMaybe<Scalars['String']['input']>;
  paginationStartIndex?: InputMaybe<Scalars['String']['input']>;
  readRepliedStatus?: InputMaybe<ReadRepliedStatus>;
  renterProgressStatus?: InputMaybe<RenterProgressStatus>;
  startDateYyyyMmDd?: InputMaybe<Scalars['String']['input']>;
  startIndex?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryZrm_GetLeadManagementCountsArgs = {
  folder?: InputMaybe<Folder>;
  includePhoneLeads?: InputMaybe<Scalars['Boolean']['input']>;
  listingAlias: Scalars['String']['input'];
  minCriteriaMatches?: InputMaybe<Scalars['Int']['input']>;
  readRepliedStatus?: InputMaybe<ReadRepliedStatus>;
  renterProgressStatus?: InputMaybe<RenterProgressStatus>;
};

export type QueryZrm_GetLeadManagementLeadsArgs = {
  clientTimeZone: Scalars['String']['input'];
  conversationId?: InputMaybe<Scalars['String']['input']>;
  folder?: InputMaybe<Folder>;
  includePhoneLeads?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  listingAlias: Scalars['String']['input'];
  minCriteriaMatches?: InputMaybe<Scalars['Int']['input']>;
  readRepliedStatus?: InputMaybe<ReadRepliedStatus>;
  renterProgressStatus?: InputMaybe<RenterProgressStatus>;
  start?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryZrm_GetLeadManagementSearchResultArgs = {
  endTimestampMs: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
  listingAlias: Scalars['String']['input'];
  offset: Scalars['Int']['input'];
  searchText: Scalars['String']['input'];
  startTimestampMs: Scalars['String']['input'];
};

export type QueryZrm_GetLeadManagementStatsArgs = {
  listingAlias: Scalars['String']['input'];
};

export type QueryZrm_GetListingPerformanceArgs = {
  endDayYyyyMmDd: Scalars['String']['input'];
  includeFreeStats?: InputMaybe<Scalars['Boolean']['input']>;
  includeMarketInsights: Scalars['Boolean']['input'];
  includeOlympus?: InputMaybe<Scalars['Boolean']['input']>;
  listingAlias?: InputMaybe<Scalars['String']['input']>;
  startDayYyyyMmDd: Scalars['String']['input'];
};

export type QueryZrm_GetPropertiesListArgs = {
  includeActive?: InputMaybe<Scalars['Boolean']['input']>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  includeAtRisk?: InputMaybe<Scalars['Boolean']['input']>;
  includeFeedClaimAndConvertUpdate?: InputMaybe<Scalars['Boolean']['input']>;
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
  includeMaintenancePartner?: InputMaybe<Scalars['Boolean']['input']>;
  includeUnarchived?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  startKeyExclusive?: InputMaybe<Scalars['String']['input']>;
};

export type QueryZrm_GetPropertyAddressArgs = {
  propertyId: Scalars['String']['input'];
};

export type QueryZrm_GetPropertySearchResultArgs = {
  includeMultifamily?: InputMaybe<Scalars['Boolean']['input']>;
  includeSingleFamily?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  startKeyExclusive?: InputMaybe<Scalars['String']['input']>;
};

export type QueryZrm_GetPropertyWebAnalyticsArgs = {
  propertyId: Scalars['String']['input'];
};

export type QueryZrm_GetZdocIdsForMessageTokensArgs = {
  messageTokens: Array<Scalars['String']['input']>;
};

export type FeatureFlagResponse = {
  __typename?: 'FeatureFlagResponse';
  canAccessBlockedUserModalFromRJSModule?: Maybe<Scalars['Boolean']['output']>;
  enableQuickResponse?: Maybe<Scalars['Boolean']['output']>;
  enableUserObjectOptimization?: Maybe<Scalars['Boolean']['output']>;
  enableWebsocketIntegration?: Maybe<Scalars['Boolean']['output']>;
};

export type Rh_Conversation = {
  __typename?: 'RH_Conversation';
  acceptsReplies?: Maybe<Scalars['Boolean']['output']>;
  acceptsRepliesExplanation?: Maybe<Scalars['String']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  application?: Maybe<Rh_Application>;
  applicationAlreadySent?: Maybe<Scalars['Boolean']['output']>;
  beds?: Maybe<Scalars['String']['output']>;
  conversation: Array<Rh_Message>;
  conversationId?: Maybe<Scalars['String']['output']>;
  encodedAlias?: Maybe<Scalars['String']['output']>;
  feedId: Scalars['String']['output'];
  feedListingId: Scalars['String']['output'];
  hasUnreadMessage: Scalars['Boolean']['output'];
  inquiryId: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  isApplicationEnabledByLandlord?: Maybe<Scalars['Boolean']['output']>;
  isApplicationsAllowed?: Maybe<Scalars['Boolean']['output']>;
  isConversationBlockedByZillow: Scalars['Boolean']['output'];
  isMultifamily?: Maybe<Scalars['Boolean']['output']>;
  landlordName?: Maybe<Scalars['String']['output']>;
  lastReadTimestampMs?: Maybe<Scalars['String']['output']>;
  listingAlias?: Maybe<Scalars['String']['output']>;
  numBathroomsHigh?: Maybe<Scalars['String']['output']>;
  numBathroomsLow?: Maybe<Scalars['String']['output']>;
  pagination?: Maybe<Rh_Pagination>;
  photoUrl?: Maybe<Scalars['String']['output']>;
  pricing?: Maybe<Scalars['String']['output']>;
  propertyTypeCode?: Maybe<Scalars['Int']['output']>;
  referenceEmail?: Maybe<Scalars['String']['output']>;
  referenceName?: Maybe<Scalars['String']['output']>;
  referenceRelayEmail?: Maybe<Scalars['String']['output']>;
  status: Rh_ConversationStatus;
};

export type Rh_Application = {
  __typename?: 'RH_Application';
  applicationAlreadySentToRenter?: Maybe<Scalars['Boolean']['output']>;
  applicationId?: Maybe<Scalars['String']['output']>;
  hasRequestedToApply?: Maybe<Scalars['Boolean']['output']>;
  isApplicationEnabledByLandlord?: Maybe<Scalars['Boolean']['output']>;
  isApplicationsAllowed?: Maybe<Scalars['Boolean']['output']>;
};

export type Rh_Message = {
  __typename?: 'RH_Message';
  attachments: Array<Rh_Attachment>;
  conversationId?: Maybe<Scalars['String']['output']>;
  isMessageOwner?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  messageDate?: Maybe<Scalars['String']['output']>;
  messageDateMs: Scalars['String']['output'];
  messageId?: Maybe<Scalars['String']['output']>;
  messageLink?: Maybe<Zrm_Cta_Link>;
  messageType: Scalars['String']['output'];
  senderEmail?: Maybe<Scalars['String']['output']>;
  senderName?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  uiTreatmentType?: Maybe<Scalars['String']['output']>;
};

export type Rh_Attachment = {
  __typename?: 'RH_Attachment';
  attachmentAddedMs?: Maybe<Scalars['String']['output']>;
  attachmentExpirationMs?: Maybe<Scalars['String']['output']>;
  attachmentMetadataStatus?: Maybe<Scalars['String']['output']>;
  downloadUrl?: Maybe<Scalars['String']['output']>;
  downloadUrlExpirationMs?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  fileSizeBytes?: Maybe<Scalars['Int']['output']>;
  fileType?: Maybe<Scalars['String']['output']>;
  isAttachmentDeleted?: Maybe<Scalars['Boolean']['output']>;
  isAttachmentExpired?: Maybe<Scalars['Boolean']['output']>;
  previewUrl?: Maybe<Scalars['String']['output']>;
  previewUrlExpirationMs?: Maybe<Scalars['String']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  zDocId?: Maybe<Scalars['String']['output']>;
};

export type Zrm_Cta_Link = {
  __typename?: 'ZRM_CTA_Link';
  linkData?: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type Rh_Pagination = {
  __typename?: 'RH_Pagination';
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  pageConversationCount?: Maybe<Scalars['Int']['output']>;
  pageStartIndex?: Maybe<Scalars['Int']['output']>;
  queryFullConversationCount?: Maybe<Scalars['Int']['output']>;
};

export type Rh_ConversationStatus = {
  __typename?: 'RH_ConversationStatus';
  isArchived: Scalars['Boolean']['output'];
  isInvitedToApply: Scalars['Boolean']['output'];
  isScheduled: Scalars['Boolean']['output'];
  isSpam: Scalars['Boolean']['output'];
};

export type User = {
  __typename?: 'User';
  applicationsEnabled: Scalars['Boolean']['output'];
  canUpdateListing: Scalars['Boolean']['output'];
  csrfToken?: Maybe<Scalars['String']['output']>;
  customers: Array<Zrm_CustomerSummary>;
  email?: Maybe<Scalars['String']['output']>;
  encodedZuid?: Maybe<Scalars['String']['output']>;
  features: Zrm_Features;
  firstName?: Maybe<Scalars['String']['output']>;
  hasAcceptedZillowRentalUserTerms?: Maybe<Scalars['Boolean']['output']>;
  hasPaidForListing?: Maybe<Scalars['Boolean']['output']>;
  hasSeenPaymentsAggregatedViewModal?: Maybe<Scalars['Boolean']['output']>;
  hasSeenRentGuarantee?: Maybe<Scalars['Boolean']['output']>;
  hasStrongAuthentication?: Maybe<Scalars['Boolean']['output']>;
  impersonatorEmail?: Maybe<Scalars['String']['output']>;
  impersonatorUserToken?: Maybe<Scalars['String']['output']>;
  isAcceptingApplications?: Maybe<Scalars['Boolean']['output']>;
  isEmailVerified?: Maybe<Scalars['Boolean']['output']>;
  isEnterpriseCustomer?: Maybe<Scalars['Boolean']['output']>;
  isHousingConnector?: Maybe<Scalars['Boolean']['output']>;
  isIdVerified?: Maybe<Scalars['Boolean']['output']>;
  isImpersonationAllowed?: Maybe<Scalars['Boolean']['output']>;
  isLeasingBeta: Scalars['Boolean']['output'];
  isMocked?: Maybe<Scalars['Boolean']['output']>;
  isMultifamilyCustomer: Scalars['Boolean']['output'];
  isPasswordlessAccount?: Maybe<Scalars['Boolean']['output']>;
  isPostingPathAdmin?: Maybe<Scalars['Boolean']['output']>;
  isPremiumCustomer?: Maybe<Scalars['Boolean']['output']>;
  isPropertyManager?: Maybe<Scalars['Boolean']['output']>;
  isPropertyManagerCompanyAdmin?: Maybe<Scalars['Boolean']['output']>;
  isRocketshipCustomer?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Field no longer supported */
  isRocketshipCustomerOnly?: Maybe<Scalars['Boolean']['output']>;
  isSelfServeCustomer?: Maybe<Scalars['Boolean']['output']>;
  isSingleFamilyEnterpriseCustomer?: Maybe<Scalars['Boolean']['output']>;
  isTwoFactorAuthEnabled?: Maybe<Scalars['Boolean']['output']>;
  isTwoFactorAuthenticated?: Maybe<Scalars['Boolean']['output']>;
  isUserBlocked?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  loggedIn: Scalars['Boolean']['output'];
  paymentsAcceptedCount?: Maybe<Scalars['Int']['output']>;
  paymentsAccessAllowed: Scalars['Boolean']['output'];
  /** @deprecated Field no longer supported */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  profileImageUrl?: Maybe<Scalars['String']['output']>;
  profiles?: Maybe<Zrm_Profiles>;
  restrictions?: Maybe<Zrm_Restrictions>;
  /** @deprecated Field no longer supported */
  roles?: Maybe<Array<Scalars['String']['output']>>;
  sessionSecondsRemaining?: Maybe<Scalars['Int']['output']>;
  setCookies?: Maybe<Array<Scalars['String']['output']>>;
  summary?: Maybe<Zrm_Summary>;
  userManagementCompanyId?: Maybe<Scalars['String']['output']>;
  userToken?: Maybe<Scalars['String']['output']>;
};

export type Zrm_CustomerSummary = {
  __typename?: 'ZRM_CustomerSummary';
  active?: Maybe<Scalars['Boolean']['output']>;
  customerType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  primaryUserAccount?: Maybe<Scalars['String']['output']>;
  userManagementCompanyId?: Maybe<Scalars['String']['output']>;
  zrnNumber?: Maybe<Scalars['String']['output']>;
};

export type Zrm_Features = {
  __typename?: 'ZRM_Features';
  canAccessAnalytics?: Maybe<Scalars['Boolean']['output']>;
  canAccessBilling?: Maybe<Scalars['Boolean']['output']>;
  canAccessBusinessVerificationLite?: Maybe<Scalars['Boolean']['output']>;
  canAccessConnectedExperience?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Field no longer supported */
  canAccessContacts?: Maybe<Scalars['Boolean']['output']>;
  canAccessDeactivationWorkflow?: Maybe<Scalars['Boolean']['output']>;
  canAccessFeatureLaunchNotifications?: Maybe<Scalars['Boolean']['output']>;
  canAccessFeedClaimAndConvert?: Maybe<Scalars['Boolean']['output']>;
  canAccessInvoicePayments?: Maybe<Scalars['Boolean']['output']>;
  canAccessListingCriteria?: Maybe<Scalars['Boolean']['output']>;
  canAccessMainAccountSettings?: Maybe<Scalars['Boolean']['output']>;
  canAccessMainAnalytics?: Maybe<Scalars['Boolean']['output']>;
  canAccessMainBilling?: Maybe<Scalars['Boolean']['output']>;
  canAccessMainContacts?: Maybe<Scalars['Boolean']['output']>;
  canAccessMainContactSupport?: Maybe<Scalars['Boolean']['output']>;
  canAccessMainHelp?: Maybe<Scalars['Boolean']['output']>;
  canAccessMainMaintenanceTracker?: Maybe<Scalars['Boolean']['output']>;
  canAccessMainMessages?: Maybe<Scalars['Boolean']['output']>;
  canAccessMainMyProperties?: Maybe<Scalars['Boolean']['output']>;
  canAccessMainNotificationCenter?: Maybe<Scalars['Boolean']['output']>;
  canAccessMainPayments?: Maybe<Scalars['Boolean']['output']>;
  canAccessMainResources?: Maybe<Scalars['Boolean']['output']>;
  canAccessMainSecuritySettings?: Maybe<Scalars['Boolean']['output']>;
  canAccessMaintenanceTracker?: Maybe<Scalars['Boolean']['output']>;
  canAccessMessages?: Maybe<Scalars['Boolean']['output']>;
  canAccessMobileHub?: Maybe<Scalars['Boolean']['output']>;
  canAccessModularListing?: Maybe<Scalars['Boolean']['output']>;
  canAccessMultiFamilyResources?: Maybe<Scalars['Boolean']['output']>;
  canAccessNewPhotoUpload?: Maybe<Scalars['Boolean']['output']>;
  canAccessPostActivationFeedListingEdits?: Maybe<Scalars['Boolean']['output']>;
  canAccessPostActivationListingEdits?: Maybe<Scalars['Boolean']['output']>;
  canAccessUserManagement?: Maybe<Scalars['Boolean']['output']>;
  canAccessUserManagementApplicationPermission?: Maybe<Scalars['Boolean']['output']>;
  canAddListing?: Maybe<Scalars['Boolean']['output']>;
  canDeleteListing?: Maybe<Scalars['Boolean']['output']>;
  canEditMultifamilyFeedListingContactInformation?: Maybe<Scalars['Boolean']['output']>;
  canRespondToReview?: Maybe<Scalars['Boolean']['output']>;
  canSwitchListingSource?: Maybe<Scalars['Boolean']['output']>;
  canUpdateListing?: Maybe<Scalars['Boolean']['output']>;
  canViewClaimFeedListing?: Maybe<Scalars['Boolean']['output']>;
  canViewContactEmailDeliverability?: Maybe<Scalars['Boolean']['output']>;
  canViewOnboardingFlow?: Maybe<Scalars['Boolean']['output']>;
  canViewSingleFamilyFeedListingDetails?: Maybe<Scalars['Boolean']['output']>;
};

export type Zrm_Profiles = {
  __typename?: 'ZRM_Profiles';
  isLandlord?: Maybe<Scalars['Boolean']['output']>;
  isPropertyManager?: Maybe<Scalars['Boolean']['output']>;
};

export type Zrm_Restrictions = {
  __typename?: 'ZRM_Restrictions';
  ctaText?: Maybe<Scalars['String']['output']>;
  ctaUrl?: Maybe<Scalars['String']['output']>;
  isAllowed?: Maybe<Scalars['Boolean']['output']>;
  messageCode?: Maybe<Scalars['String']['output']>;
  partialMessages?: Maybe<Array<Maybe<Zrm_PartialMessages>>>;
  title?: Maybe<Scalars['String']['output']>;
};

export type Zrm_PartialMessages = {
  __typename?: 'ZRM_PartialMessages';
  className?: Maybe<Scalars['String']['output']>;
  isBold?: Maybe<Scalars['Boolean']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type Zrm_Summary = {
  __typename?: 'ZRM_Summary';
  activeListingCount?: Maybe<Scalars['Int']['output']>;
  totalListingCount?: Maybe<Scalars['Int']['output']>;
};

export enum Folder {
  Archived = 'ARCHIVED',
  Favorite = 'FAVORITE',
  Inbox = 'INBOX',
  ShowAll = 'SHOW_ALL',
  Spam = 'SPAM',
}

export type Rh_ConversationResponse = {
  __typename?: 'RH_ConversationResponse';
  conversations: Array<Rh_Conversation>;
  pagination?: Maybe<Rh_Pagination>;
};

export type Rh_SyndicationUrls = {
  __typename?: 'RH_SyndicationUrls';
  hotpadsUrl?: Maybe<Scalars['String']['output']>;
  truliaUrl?: Maybe<Scalars['String']['output']>;
  zillowUrl?: Maybe<Scalars['String']['output']>;
};

export type Zrm_AbTestVersionsResponse = {
  __typename?: 'ZRM_AbTestVersionsResponse';
  experimentDtos: Array<Zrm_Experiment>;
};

export type Zrm_Experiment = {
  __typename?: 'ZRM_Experiment';
  experimentName: Scalars['String']['output'];
  experimentPercent?: Maybe<Scalars['Int']['output']>;
  jira: Scalars['String']['output'];
  shouldTrack: Scalars['Boolean']['output'];
  version: Scalars['String']['output'];
};

export type Zrm_AggregateConversationCount = {
  __typename?: 'ZRM_AggregateConversationCount';
  notRepliedToCount?: Maybe<Scalars['Int']['output']>;
  totalConversationsCount?: Maybe<Scalars['Int']['output']>;
  unreadCount?: Maybe<Scalars['Int']['output']>;
};

export type Zrm_GetAttachmentsByConversationIdResponse = {
  __typename?: 'ZRM_getAttachmentsByConversationIdResponse';
  attachments: Array<Zrm_Attachment>;
};

export type Zrm_Attachment = {
  __typename?: 'ZRM_Attachment';
  attachmentAddedMs?: Maybe<Scalars['String']['output']>;
  attachmentExpirationMs?: Maybe<Scalars['String']['output']>;
  attachmentMetadataStatus?: Maybe<Scalars['String']['output']>;
  downloadUrl?: Maybe<Scalars['String']['output']>;
  downloadUrlExpirationMs?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  fileSizeBytes?: Maybe<Scalars['Int']['output']>;
  fileType?: Maybe<Scalars['String']['output']>;
  isAttachmentDeleted?: Maybe<Scalars['Boolean']['output']>;
  isAttachmentExpired?: Maybe<Scalars['Boolean']['output']>;
  previewUrl?: Maybe<Scalars['String']['output']>;
  previewUrlExpirationMs?: Maybe<Scalars['String']['output']>;
  sortOrder?: Maybe<Scalars['Int']['output']>;
  zDocId?: Maybe<Scalars['String']['output']>;
};

export type Zrm_ConnectedExperience = {
  __typename?: 'ZRM_connectedExperience';
  isConnectedExperience?: Maybe<Scalars['Boolean']['output']>;
};

export type Zrm_Conversation = {
  __typename?: 'ZRM_Conversation';
  acceptsReplies?: Maybe<Scalars['Boolean']['output']>;
  activeParticipantsInConversation: Array<Zrm_ConversationParticipant>;
  address?: Maybe<Scalars['String']['output']>;
  applicationAlreadySent?: Maybe<Scalars['Boolean']['output']>;
  applicationCompleted?: Maybe<Scalars['Boolean']['output']>;
  attributes?: Maybe<Zrm_ConversationAttributes>;
  conversation: Array<Zrm_Message>;
  conversationId: Scalars['String']['output'];
  feedId: Scalars['String']['output'];
  feedListingId: Scalars['String']['output'];
  hasQuickResponses?: Maybe<Scalars['Boolean']['output']>;
  hasUnreadMessage: Scalars['Boolean']['output'];
  inquiry?: Maybe<Zrm_Inquiry>;
  inquiryId: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  isApplicationsAccepted: Scalars['Boolean']['output'];
  isApplicationsAllowed: Scalars['Boolean']['output'];
  isConversationBlockedByZillow: Scalars['Boolean']['output'];
  isMultifamily: Scalars['Boolean']['output'];
  lastReadTimestampMs?: Maybe<Scalars['String']['output']>;
  listingAlias: Scalars['String']['output'];
  listingId: Scalars['String']['output'];
  note: Zrm_Note;
  notRepliedTo: Scalars['Boolean']['output'];
  pagination?: Maybe<Zrm_Pagination>;
  propertyTypeCode?: Maybe<Scalars['Int']['output']>;
  quickResponses?: Maybe<Zrm_QuickResponses>;
  referenceEmail?: Maybe<Scalars['String']['output']>;
  referenceName?: Maybe<Scalars['String']['output']>;
  referenceRelayEmail?: Maybe<Scalars['String']['output']>;
  rentalProtection?: Maybe<Zrm_RentalProtection>;
  renterProfile?: Maybe<Zrm_RenterProfile>;
  status: Zrm_ConversationStatus;
  statusLabel?: Maybe<Zrm_StatusLabel>;
};

export type Zrm_ConversationParticipant = {
  __typename?: 'ZRM_ConversationParticipant';
  name: Scalars['String']['output'];
  relayAddress?: Maybe<Scalars['String']['output']>;
};

export type Zrm_ConversationAttributes = {
  __typename?: 'ZRM_ConversationAttributes';
  applicationMarkedSent?: Maybe<Scalars['Boolean']['output']>;
  attributeUpdateDateMs?: Maybe<Scalars['String']['output']>;
  tourScheduledTimestampMs?: Maybe<Scalars['String']['output']>;
};

export type Zrm_Message = {
  __typename?: 'ZRM_Message';
  attachments: Array<Zrm_Attachment>;
  conversationId?: Maybe<Scalars['String']['output']>;
  ctaLink?: Maybe<Scalars['String']['output']>;
  ctaText?: Maybe<Scalars['String']['output']>;
  isMessageOwner?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  messageDate?: Maybe<Scalars['String']['output']>;
  messageDateMs: Scalars['String']['output'];
  messageId?: Maybe<Scalars['String']['output']>;
  messageLink?: Maybe<Zrm_Cta_Link>;
  messagePreview?: Maybe<Scalars['String']['output']>;
  messageType: Scalars['String']['output'];
  senderEmail?: Maybe<Scalars['String']['output']>;
  senderName?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  uiTreatmentType?: Maybe<Scalars['String']['output']>;
};

export type Zrm_Inquiry = {
  __typename?: 'ZRM_Inquiry';
  attributes?: Maybe<Zrm_RenterResume>;
  contactEmail?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  feed?: Maybe<Scalars['String']['output']>;
  feedListingId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  inquirerType?: Maybe<Scalars['String']['output']>;
  isAttributesHidden?: Maybe<Scalars['Boolean']['output']>;
  isPhoneLead?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['String']['output']>;
};

export type Zrm_RenterResume = {
  __typename?: 'ZRM_RenterResume';
  credit?: Maybe<Scalars['String']['output']>;
  desiredParking?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  income?: Maybe<Scalars['String']['output']>;
  introduction?: Maybe<Scalars['String']['output']>;
  isSmoker?: Maybe<Scalars['Boolean']['output']>;
  jobTitle?: Maybe<Scalars['String']['output']>;
  leaseLengthMonths?: Maybe<Scalars['String']['output']>;
  moveInTimeframe?: Maybe<Scalars['String']['output']>;
  numOccupants?: Maybe<Scalars['String']['output']>;
  pets?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  reasonForMoving?: Maybe<Scalars['String']['output']>;
  updatedAtMs?: Maybe<Scalars['String']['output']>;
};

export type Zrm_Note = {
  __typename?: 'ZRM_Note';
  conversationId?: Maybe<Scalars['String']['output']>;
  lastUpdatedMs?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
};

export type Zrm_Pagination = {
  __typename?: 'ZRM_Pagination';
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  pageConversationCount?: Maybe<Scalars['Int']['output']>;
  pageStartIndex?: Maybe<Scalars['Int']['output']>;
  queryFullConversationCount?: Maybe<Scalars['Int']['output']>;
  queryFullMessageCount?: Maybe<Scalars['Int']['output']>;
};

export type Zrm_QuickResponses = {
  __typename?: 'ZRM_QuickResponses';
  prediction?: Maybe<Scalars['String']['output']>;
  suggestions?: Maybe<Array<Maybe<Zrm_QuickResponses_Suggestions>>>;
};

export type Zrm_QuickResponses_Suggestions = {
  __typename?: 'ZRM_QuickResponses_Suggestions';
  id?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type Zrm_RentalProtection = {
  __typename?: 'ZRM_RentalProtection';
  isEligible?: Maybe<Scalars['Boolean']['output']>;
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  relativePath?: Maybe<Scalars['String']['output']>;
};

export type Zrm_RenterProfile = {
  __typename?: 'ZRM_RenterProfile';
  attributes?: Maybe<Zrm_RenterProfile_Attributes>;
  isRenterProfileHidden?: Maybe<Scalars['Boolean']['output']>;
  leadIntentValue?: Maybe<Scalars['String']['output']>;
  renterProfileCompleteness?: Maybe<Scalars['String']['output']>;
  shouldShowRequestRenterProfileCta?: Maybe<Scalars['Boolean']['output']>;
};

export type Zrm_RenterProfile_Attributes = {
  __typename?: 'ZRM_RenterProfile_Attributes';
  credit?: Maybe<Scalars['String']['output']>;
  desiredParking?: Maybe<Scalars['String']['output']>;
  incomeYearly?: Maybe<Scalars['String']['output']>;
  incomeYearlyRange?: Maybe<Scalars['String']['output']>;
  introduction?: Maybe<Scalars['String']['output']>;
  isSmoker?: Maybe<Scalars['String']['output']>;
  isSmokerBoolean?: Maybe<Scalars['Boolean']['output']>;
  jobTitle?: Maybe<Scalars['String']['output']>;
  leaseLengthMonths?: Maybe<Scalars['String']['output']>;
  moveInDate?: Maybe<Scalars['String']['output']>;
  numBedrooms?: Maybe<Scalars['String']['output']>;
  numOccupants?: Maybe<Scalars['String']['output']>;
  petDetails?: Maybe<Array<Maybe<Zrm_RenterProfile_PetDetails>>>;
  reasonForMoving?: Maybe<Scalars['String']['output']>;
  updatedAtMs?: Maybe<Scalars['String']['output']>;
  voucherAmountMonthly?: Maybe<Scalars['String']['output']>;
};

export type Zrm_RenterProfile_PetDetails = {
  __typename?: 'ZRM_RenterProfile_PetDetails';
  breed?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  weightPounds?: Maybe<Scalars['String']['output']>;
};

export type Zrm_ConversationStatus = {
  __typename?: 'ZRM_ConversationStatus';
  isArchived: Scalars['Boolean']['output'];
  isFavorite: Scalars['Boolean']['output'];
  isInvitedToApply: Scalars['Boolean']['output'];
  isScheduled: Scalars['Boolean']['output'];
  isSpam: Scalars['Boolean']['output'];
};

export type Zrm_StatusLabel = {
  __typename?: 'ZRM_StatusLabel';
  linkData?: Maybe<Scalars['String']['output']>;
  linkId: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type Zrm_ListingStats = {
  __typename?: 'ZRM_ListingStats';
  aliasEncoded?: Maybe<Scalars['String']['output']>;
  listingAlias?: Maybe<Scalars['String']['output']>;
  listingId?: Maybe<Scalars['String']['output']>;
  notRepliedToCount?: Maybe<Scalars['Int']['output']>;
  totalConversationsCount?: Maybe<Scalars['Int']['output']>;
  unreadCount?: Maybe<Scalars['Int']['output']>;
};

export type ConversationInformation = {
  __typename?: 'ConversationInformation';
  conversationId: Scalars['String']['output'];
  encodedAlias: Scalars['String']['output'];
  listingAlias: Scalars['String']['output'];
  referenceId: Scalars['String']['output'];
  referenceIdType: Scalars['String']['output'];
  renterBrand: Scalars['String']['output'];
  renterEmailAddress: Scalars['String']['output'];
  renterName?: Maybe<Scalars['String']['output']>;
};

export type Zrm_GetConversationSearchResultResponse = {
  __typename?: 'ZRM_getConversationSearchResultResponse';
  hasMore: Scalars['Boolean']['output'];
  searchResult: Array<Maybe<Zrm_ConversationSearchResult>>;
};

export type Zrm_ConversationSearchResult = {
  __typename?: 'ZRM_ConversationSearchResult';
  conversationId?: Maybe<Scalars['String']['output']>;
  folder?: Maybe<Scalars['String']['output']>;
  listingAlias?: Maybe<Scalars['String']['output']>;
  renterName?: Maybe<Scalars['String']['output']>;
  renterPhoneNumber?: Maybe<Scalars['String']['output']>;
  streetAddress?: Maybe<Scalars['String']['output']>;
};

export type Zrm_GetExperimentTreatmentResponse = {
  __typename?: 'ZRM_getExperimentTreatmentResponse';
  featureName?: Maybe<Scalars['String']['output']>;
  treatment?: Maybe<Scalars['String']['output']>;
};

export type Zrm_GetFunnelReportV2Response = {
  __typename?: 'ZRM_getFunnelReportV2Response';
  analytics?: Maybe<Array<Maybe<Zrm_FunnelReportAnalytics>>>;
  clickCount?: Maybe<Scalars['Int']['output']>;
  daysOnMarketCount?: Maybe<Scalars['Int']['output']>;
  impressionCount?: Maybe<Scalars['Int']['output']>;
  insights?: Maybe<Zrm_FunnelReportInsights>;
  insightsByProductType?: Maybe<Zrm_FunnelReportProductTypeInsights>;
  leadCount?: Maybe<Scalars['Int']['output']>;
  viewCount?: Maybe<Scalars['Int']['output']>;
};

export type Zrm_FunnelReportAnalytics = {
  __typename?: 'ZRM_FunnelReportAnalytics';
  averageStarLevel?: Maybe<Scalars['Int']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  clickCount?: Maybe<Scalars['Int']['output']>;
  daysOnMarketCount?: Maybe<Scalars['Int']['output']>;
  emailLeadCount?: Maybe<Scalars['Int']['output']>;
  feedId?: Maybe<Scalars['String']['output']>;
  feedListingId?: Maybe<Scalars['String']['output']>;
  impressionCount?: Maybe<Scalars['Int']['output']>;
  isSingleFamily?: Maybe<Scalars['Boolean']['output']>;
  leadCount?: Maybe<Scalars['Int']['output']>;
  leaseCount?: Maybe<Scalars['Int']['output']>;
  listingName?: Maybe<Scalars['String']['output']>;
  percentageResponse?: Maybe<Scalars['Float']['output']>;
  phoneLeadCount?: Maybe<Scalars['Int']['output']>;
  productType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  publishedStatus?: Maybe<Scalars['String']['output']>;
  reviewCount?: Maybe<Scalars['Int']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  viewCount?: Maybe<Scalars['Int']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type Zrm_FunnelReportInsights = {
  __typename?: 'ZRM_FunnelReportInsights';
  market?: Maybe<Zrm_FunnelReportMarketInsights>;
  portfolio?: Maybe<Zrm_FunnelReportPortfolioInsights>;
  portfolioLeadsTotal?: Maybe<Scalars['Int']['output']>;
  portfolioTotalListings?: Maybe<Scalars['Int']['output']>;
};

export type Zrm_FunnelReportMarketInsights = {
  __typename?: 'ZRM_FunnelReportMarketInsights';
  daysOnMarketAverage?: Maybe<Scalars['Float']['output']>;
  impressionsAverage?: Maybe<Scalars['Float']['output']>;
  leadsAverage?: Maybe<Scalars['Float']['output']>;
  leadsRate?: Maybe<Scalars['Float']['output']>;
  reviewAverage?: Maybe<Scalars['Float']['output']>;
  viewsAverage?: Maybe<Scalars['Float']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type Zrm_FunnelReportPortfolioInsights = {
  __typename?: 'ZRM_FunnelReportPortfolioInsights';
  daysOnMarketAverage?: Maybe<Scalars['Float']['output']>;
  impressionsAverage?: Maybe<Scalars['Float']['output']>;
  leadsAverage?: Maybe<Scalars['Float']['output']>;
  leadsRate?: Maybe<Scalars['Float']['output']>;
  reviewAverage?: Maybe<Scalars['Float']['output']>;
  viewsAverage?: Maybe<Scalars['Float']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type Zrm_FunnelReportProductTypeInsights = {
  __typename?: 'ZRM_FunnelReportProductTypeInsights';
  FLAT_FEE?: Maybe<Zrm_FunnelReportInsights>;
  PAY_PER_LEAD?: Maybe<Zrm_FunnelReportInsights>;
  PREMIUM_PLUS_PACKAGE?: Maybe<Zrm_FunnelReportInsights>;
};

export enum ReadRepliedStatus {
  NotRepliedTo = 'NOT_REPLIED_TO',
  ShowAll = 'SHOW_ALL',
  Unread = 'UNREAD',
}

export enum RenterProgressStatus {
  Applicants = 'APPLICANTS',
  Inquiries = 'INQUIRIES',
  ShowAll = 'SHOW_ALL',
  Tenants = 'TENANTS',
  Tours = 'TOURS',
}

export type Zrm_ConversationResponse = {
  __typename?: 'ZRM_ConversationResponse';
  conversations: Array<Zrm_Conversation>;
  listingId?: Maybe<Scalars['String']['output']>;
  pagination?: Maybe<Zrm_Pagination>;
};

export type Zrm_GetLeadManagementCountsResponse = {
  __typename?: 'ZRM_getLeadManagementCountsResponse';
  totalLeadCount: Scalars['Int']['output'];
};

export type Zrm_GetLeadManagementLeadsResponse = {
  __typename?: 'ZRM_getLeadManagementLeadsResponse';
  earliestDateSearchedMs: Scalars['String']['output'];
  hasNextPage: Scalars['Boolean']['output'];
  leads: Array<Zrm_LeadManagementLead>;
  listingDetails: Zrm_LeadManagementListingDetail;
  pageLeadCount: Scalars['Int']['output'];
  screeningCriteriaDetails: Zrm_LeadManagementScreeningCriteriaDetail;
  tooMuchDataRequested: Scalars['Boolean']['output'];
  totalLeadCount: Scalars['Int']['output'];
};

export type Zrm_LeadManagementLead = {
  __typename?: 'ZRM_LeadManagementLead';
  applicationInfo: Zrm_LeadManagementApplicationInfo;
  attributes?: Maybe<Zrm_LeadManagementConversationAttributes>;
  conversationId: Scalars['String']['output'];
  latestContact: Zrm_LeadManagementLatestContact;
  nextStep: Zrm_LeadManagementNextStep;
  renterInfo: Zrm_LeadManagementRenterInfo;
  renterProfile?: Maybe<Zrm_RenterProfile>;
  renterProgressBar: Zrm_LeadManagementRenterProgressBar;
  screeningCriteria: Zrm_LeadManagementScreeningCriteria;
  status: Zrm_LeadManagementConversationStatus;
  statusLabel?: Maybe<Zrm_StatusLabel>;
};

export type Zrm_LeadManagementApplicationInfo = {
  __typename?: 'ZRM_LeadManagementApplicationInfo';
  isApplicationCompleted: Scalars['Boolean']['output'];
  isApplicationsAccepted: Scalars['Boolean']['output'];
  isApplicationSent: Scalars['Boolean']['output'];
  numCoApplicants: Scalars['Int']['output'];
};

export type Zrm_LeadManagementConversationAttributes = {
  __typename?: 'ZRM_LeadManagementConversationAttributes';
  applicationMarkedSent: Scalars['Boolean']['output'];
  note?: Maybe<Scalars['String']['output']>;
  tourScheduledTimestampMs?: Maybe<Scalars['String']['output']>;
};

export type Zrm_LeadManagementLatestContact = {
  __typename?: 'ZRM_LeadManagementLatestContact';
  hasAttachments: Scalars['Boolean']['output'];
  isMessageOwner: Scalars['Boolean']['output'];
  isPhoneLead: Scalars['Boolean']['output'];
  isRead: Scalars['Boolean']['output'];
  messageDateMs: Scalars['String']['output'];
  messageText?: Maybe<Scalars['String']['output']>;
  messageType: Scalars['String']['output'];
  notRepliedTo: Scalars['Boolean']['output'];
};

export type Zrm_LeadManagementNextStep = {
  __typename?: 'ZRM_LeadManagementNextStep';
  link: Zrm_LeadManagementNextStepLink;
  nextStepType: Scalars['String']['output'];
};

export type Zrm_LeadManagementNextStepLink = {
  __typename?: 'ZRM_LeadManagementNextStepLink';
  linkData?: Maybe<Scalars['String']['output']>;
  linkId: Scalars['String']['output'];
  text: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type Zrm_LeadManagementRenterInfo = {
  __typename?: 'ZRM_LeadManagementRenterInfo';
  firstContactDateMs: Scalars['String']['output'];
  renterName?: Maybe<Scalars['String']['output']>;
  renterPhoneNumber?: Maybe<Scalars['String']['output']>;
  renterRelayEmailAddress?: Maybe<Scalars['String']['output']>;
};

export type Zrm_LeadManagementRenterProgressBar = {
  __typename?: 'ZRM_LeadManagementRenterProgressBar';
  application: Zrm_LeadManagementProgressBarStatus;
  inquiry: Zrm_LeadManagementProgressBarStatus;
  lease: Zrm_LeadManagementProgressBarStatus;
  tour: Zrm_LeadManagementProgressBarStatus;
};

export type Zrm_LeadManagementProgressBarStatus = {
  __typename?: 'ZRM_LeadManagementProgressBarStatus';
  hasStatusLabel: Scalars['Boolean']['output'];
  statusType: Scalars['String']['output'];
};

export type Zrm_LeadManagementScreeningCriteria = {
  __typename?: 'ZRM_LeadManagementScreeningCriteria';
  criteria: Array<Zrm_LeadManagementCriterion>;
  criteriaMatchedDisplay: Scalars['String']['output'];
  hasScreeningCriteria: Scalars['Boolean']['output'];
  hasSubmittedProfile: Scalars['Boolean']['output'];
  numCriteriaSelectedByLandlord?: Maybe<Scalars['Int']['output']>;
  numRequiredCriteriaSelectedByLandlord: Scalars['Int']['output'];
  numRequiredOrNegotiableCriteriaSelectedByLandlordThatMatch?: Maybe<Scalars['Int']['output']>;
  shouldShowRequestRenterProfileCta: Scalars['Boolean']['output'];
};

export type Zrm_LeadManagementCriterion = {
  __typename?: 'ZRM_LeadManagementCriterion';
  hasMatchingCriterion: Scalars['Boolean']['output'];
  isCriterionSet: Scalars['Boolean']['output'];
  isNegotiable: Scalars['Boolean']['output'];
  renterDataToolTipText?: Maybe<Scalars['String']['output']>;
  rentersCriterionSubmittedDisplay?: Maybe<Scalars['String']['output']>;
  screeningCriteriaType: Scalars['String']['output'];
  screeningCriterionDisplay?: Maybe<Scalars['String']['output']>;
  screeningCriterionNameDisplay: Scalars['String']['output'];
};

export type Zrm_LeadManagementConversationStatus = {
  __typename?: 'ZRM_LeadManagementConversationStatus';
  applicationMarkedSent: Scalars['Boolean']['output'];
  isArchived: Scalars['Boolean']['output'];
  isConversationBlockedByZillow: Scalars['Boolean']['output'];
  isFavorite: Scalars['Boolean']['output'];
  isScheduled: Scalars['Boolean']['output'];
  isSpam: Scalars['Boolean']['output'];
};

export type Zrm_LeadManagementListingDetail = {
  __typename?: 'ZRM_LeadManagementListingDetail';
  listingAddress: Scalars['String']['output'];
  listingAlias: Scalars['String']['output'];
};

export type Zrm_LeadManagementScreeningCriteriaDetail = {
  __typename?: 'ZRM_LeadManagementScreeningCriteriaDetail';
  hasCriteriaSet: Scalars['Boolean']['output'];
  isScreeningCriteriaIncomplete: Scalars['Boolean']['output'];
};

export type Zrm_GetLeadManagementSearchResultResponse = {
  __typename?: 'ZRM_getLeadManagementSearchResultResponse';
  hasMore: Scalars['Boolean']['output'];
  responseEntries: Array<Maybe<Zrm_GetLeadManagementSearchResultResponseEntry>>;
};

export type Zrm_GetLeadManagementSearchResultResponseEntry = {
  __typename?: 'ZRM_getLeadManagementSearchResultResponseEntry';
  conversationId: Scalars['String']['output'];
  screeningCriteria: Zrm_LeadManagementSearchScreeningCriteria;
  searchEntry: Zrm_LeadManagementSearchEntry;
};

export type Zrm_LeadManagementSearchScreeningCriteria = {
  __typename?: 'ZRM_LeadManagementSearchScreeningCriteria';
  criteriaMatchedDisplay?: Maybe<Scalars['String']['output']>;
  numCriteriaSelectedByLandlord?: Maybe<Scalars['Int']['output']>;
  numCriteriaSelectedByLandlordThatPossiblyMatch?: Maybe<Scalars['Int']['output']>;
  numRequiredCriteriaSelectedByLandlord?: Maybe<Scalars['Int']['output']>;
  numRequiredCriteriaSelectedByLandlordThatMatch?: Maybe<Scalars['Int']['output']>;
  numRequiredOrNegotiableCriteriaSelectedByLandlordThatMatch?: Maybe<Scalars['Int']['output']>;
  numSelectableCriteria?: Maybe<Scalars['Int']['output']>;
};

export type Zrm_LeadManagementSearchEntry = {
  __typename?: 'ZRM_LeadManagementSearchEntry';
  conversationId?: Maybe<Scalars['String']['output']>;
  folder?: Maybe<Scalars['String']['output']>;
  listingAlias?: Maybe<Scalars['String']['output']>;
  renterName?: Maybe<Scalars['String']['output']>;
  renterPhoneNumber?: Maybe<Scalars['String']['output']>;
  streetAddress?: Maybe<Scalars['String']['output']>;
};

export type Zrm_GetLeadManagementStatsResponse = {
  __typename?: 'ZRM_getLeadManagementStatsResponse';
  hasCriteriaSet: Scalars['Boolean']['output'];
  leadsQualifiedForCriteriaTotal: Scalars['Int']['output'];
  listingAddress: Scalars['String']['output'];
  stats: Array<Maybe<Zrm_LeadManagementStats>>;
};

export type Zrm_LeadManagementStats = {
  __typename?: 'ZRM_LeadManagementStats';
  criterionMatchedCount: Scalars['Int']['output'];
  isCriterionSet: Scalars['Boolean']['output'];
  isNegotiable: Scalars['Boolean']['output'];
  percentageMatched: Scalars['String']['output'];
  screeningCriteriaType: Scalars['String']['output'];
  screeningCriterionDisplay?: Maybe<Scalars['String']['output']>;
  screeningCriterionNameDisplay: Scalars['String']['output'];
};

export type Zrm_GetListingPerformanceResponse = {
  __typename?: 'ZRM_getListingPerformanceResponse';
  analytics: Array<Maybe<ListingAnalytics>>;
  insights: Zrm_Insights;
};

export type ListingAnalytics = {
  __typename?: 'ListingAnalytics';
  clickCount: Scalars['Int']['output'];
  feedId: Scalars['String']['output'];
  feedListingId: Scalars['String']['output'];
  impressionCount: Scalars['Int']['output'];
  leadCount: Scalars['Int']['output'];
  listingAliases: Array<Scalars['String']['output']>;
  listingName: Scalars['String']['output'];
  viewCount: Scalars['Int']['output'];
};

export type Zrm_Insights = {
  __typename?: 'ZRM_Insights';
  market: MarketInsights;
  portfolio: PortfolioInsights;
  portfolioClickCount: Scalars['Int']['output'];
  portfolioDaysOnMarketCount: Scalars['Int']['output'];
  portfolioImpressionCount: Scalars['Int']['output'];
  portfolioLeadsTotal: Scalars['Int']['output'];
  portfolioTotalListings: Scalars['Int']['output'];
  portfolioViewCount: Scalars['Int']['output'];
};

export type MarketInsights = {
  __typename?: 'MarketInsights';
  clickAverage: Scalars['Float']['output'];
  daysOnMarketAverage: Scalars['Float']['output'];
  impressionsAverage: Scalars['Float']['output'];
  leadsAverage: Scalars['Float']['output'];
  leadsRate: Scalars['Float']['output'];
  reviewAverage: Scalars['Float']['output'];
  viewsAverage: Scalars['Float']['output'];
  weight: Scalars['Float']['output'];
};

export type PortfolioInsights = {
  __typename?: 'PortfolioInsights';
  clickAverage: Scalars['Float']['output'];
  daysOnMarketAverage: Scalars['Float']['output'];
  impressionsAverage: Scalars['Float']['output'];
  leadsAverage: Scalars['Float']['output'];
  leadsRate: Scalars['Float']['output'];
  reviewAverage: Scalars['Float']['output'];
  viewsAverage: Scalars['Float']['output'];
  weight: Scalars['Float']['output'];
};

export type Zrm_GetPropertiesListResponse = {
  __typename?: 'ZRM_GetPropertiesListResponse';
  listingCount: Zrm_PropertyListingCount;
  listings: Array<Zrm_PropertyListing>;
  pager: Zrm_GetPropertiesListPagination;
};

export type Zrm_PropertyListingCount = {
  __typename?: 'ZRM_PropertyListingCount';
  active?: Maybe<Scalars['Int']['output']>;
  archived?: Maybe<Scalars['Int']['output']>;
  atRisk?: Maybe<Scalars['Int']['output']>;
  inactive?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type Zrm_PropertyListing = {
  __typename?: 'ZRM_PropertyListing';
  address?: Maybe<Zrm_PropertyListingAddress>;
  isMultifamily?: Maybe<Scalars['Boolean']['output']>;
  listingAlias?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type Zrm_PropertyListingAddress = {
  __typename?: 'ZRM_PropertyListingAddress';
  city?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type Zrm_GetPropertiesListPagination = {
  __typename?: 'ZRM_GetPropertiesListPagination';
  endKey?: Maybe<Scalars['String']['output']>;
  hasMore?: Maybe<Scalars['Boolean']['output']>;
  startKey?: Maybe<Scalars['String']['output']>;
};

export type Zrm_GetPropertyAddressResponse = {
  __typename?: 'ZRM_GetPropertyAddressResponse';
  city?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type Zrm_GetPropertySearchResultResponse = {
  __typename?: 'ZRM_GetPropertySearchResultResponse';
  listings: Array<Zrm_PropertyListing>;
  pager: Zrm_GetPropertiesListPagination;
};

export type Zrm_GetPropertyWebAnalyticsResponse = {
  __typename?: 'ZRM_GetPropertyWebAnalyticsResponse';
  eventProductType?: Maybe<Scalars['String']['output']>;
  isApplicationsAccepted?: Maybe<Scalars['Boolean']['output']>;
  listingAlias?: Maybe<Scalars['String']['output']>;
  rentGuarantee?: Maybe<Zrm_RentGuarantee>;
};

export type Zrm_RentGuarantee = {
  __typename?: 'ZRM_RentGuarantee';
  isEligible?: Maybe<Scalars['Boolean']['output']>;
};

export type Zrm_GetOrAddSavedRepliesResponse = {
  __typename?: 'ZRM_getOrAddSavedRepliesResponse';
  customReplies: Array<Maybe<SavedReply>>;
  defaultSavedReplies: Array<SavedReply>;
  success: Scalars['Boolean']['output'];
};

export type SavedReply = {
  __typename?: 'SavedReply';
  dateUpdatedMs?: Maybe<Scalars['String']['output']>;
  reply: Scalars['String']['output'];
  replyIndex: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  RH_addMessageToConversation: Rh_Message;
  RH_addMessageToConversationV2: Rh_Message;
  RH_deleteAttachments?: Maybe<Rh_SuccessStatusResponse>;
  RH_RequestToApply: Rh_RequestToApplyResponse;
  RH_updateConversationStatus?: Maybe<Rh_SuccessStatusResponse>;
  RH_updateConversationStatusV2: Rh_SuccessStatusResponse;
  ZRM_addMessageToConversationV2: Zrm_Message;
  ZRM_addSavedReplies: Zrm_GetOrAddSavedRepliesResponse;
  ZRM_addSystemMessageToConversation: Zrm_AddSystemMessageToConversationResponse;
  ZRM_applicationsAccepted?: Maybe<Zrm_SuccessStatusResponse>;
  ZRM_deleteAttachments: Zrm_SuccessStatusResponse;
  ZRM_deleteSavedReplies: Zrm_SuccessStatusResponse;
  ZRM_editSavedReply: Zrm_SuccessStatusResponse;
  ZRM_enableApplications?: Maybe<Zrm_SuccessStatusResponse>;
  ZRM_inviteToApply: Zrm_InviteResponse;
  ZRM_markConversationAsUnread: Zrm_SuccessStatusResponse;
  ZRM_updateConversationAttributes: Zrm_SuccessStatusResponse;
  ZRM_updateConversationStatus: Zrm_SuccessStatusResponse;
  ZRM_updateConversationStatusV2: Zrm_SuccessStatusResponse;
  ZRM_updateNote: Zrm_SuccessStatusResponse;
};

export type MutationRh_AddMessageToConversationArgs = {
  conversationId: Scalars['String']['input'];
  isMessageOwner?: InputMaybe<Scalars['Boolean']['input']>;
  message: Scalars['String']['input'];
};

export type MutationRh_AddMessageToConversationV2Args = {
  conversationId: Scalars['String']['input'];
  message: Scalars['String']['input'];
  zDocIds: Array<Scalars['String']['input']>;
};

export type MutationRh_DeleteAttachmentsArgs = {
  attachmentsToBeDeleted: Array<Rh_AttachmentToBeDeletedArg>;
  conversationId: Scalars['String']['input'];
  listingAlias: Scalars['String']['input'];
};

export type MutationRh_RequestToApplyArgs = {
  alias?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  requestToApply?: InputMaybe<Scalars['Boolean']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type MutationRh_UpdateConversationStatusArgs = {
  conversationId: Scalars['String']['input'];
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isSpam?: InputMaybe<Scalars['Boolean']['input']>;
  lastReadMs?: InputMaybe<Scalars['String']['input']>;
};

export type MutationRh_UpdateConversationStatusV2Args = {
  conversationId: Scalars['String']['input'];
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  lastReadMs?: InputMaybe<Scalars['String']['input']>;
  reportReasonType?: InputMaybe<ReportConversationReason>;
  userReportComment?: InputMaybe<Scalars['String']['input']>;
};

export type MutationZrm_AddMessageToConversationV2Args = {
  conversationId: Scalars['String']['input'];
  listingAlias?: InputMaybe<Scalars['String']['input']>;
  message: Scalars['String']['input'];
  quickResponseSuggestionId?: InputMaybe<Scalars['String']['input']>;
  zDocIds: Array<Scalars['String']['input']>;
};

export type MutationZrm_AddSavedRepliesArgs = {
  savedReplies: Array<SavedReplyArg>;
};

export type MutationZrm_AddSystemMessageToConversationArgs = {
  conversationId: Scalars['String']['input'];
  messageType: Scalars['String']['input'];
};

export type MutationZrm_ApplicationsAcceptedArgs = {
  applicationsAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  listingAlias: Scalars['String']['input'];
  requireUserName?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationZrm_DeleteAttachmentsArgs = {
  attachmentsToBeDeleted: Array<Zrm_AttachmentToBeDeletedArg>;
  conversationId: Scalars['String']['input'];
  listingAlias: Scalars['String']['input'];
};

export type MutationZrm_DeleteSavedRepliesArgs = {
  savedReplyIndices: Array<Scalars['Int']['input']>;
};

export type MutationZrm_EditSavedReplyArgs = {
  savedReply: SavedReplyArg;
};

export type MutationZrm_InviteToApplyArgs = {
  listingId: Scalars['String']['input'];
  renterFirstName: Scalars['String']['input'];
  renterLastName: Scalars['String']['input'];
  toEmail: Scalars['String']['input'];
};

export type MutationZrm_MarkConversationAsUnreadArgs = {
  conversationId: Scalars['String']['input'];
};

export type MutationZrm_UpdateConversationAttributesArgs = {
  applicationMarkedSent?: InputMaybe<Scalars['Boolean']['input']>;
  conversationId: Scalars['String']['input'];
  isFavorite?: InputMaybe<Scalars['Boolean']['input']>;
  listingAlias?: InputMaybe<Scalars['String']['input']>;
  listingId?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  tourScheduledTimestampMs?: InputMaybe<Scalars['String']['input']>;
};

export type MutationZrm_UpdateConversationStatusArgs = {
  conversationId: Scalars['String']['input'];
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isSpam?: InputMaybe<Scalars['Boolean']['input']>;
  lastReadMs?: InputMaybe<Scalars['String']['input']>;
  listingAlias?: InputMaybe<Scalars['String']['input']>;
  listingId?: InputMaybe<Scalars['String']['input']>;
};

export type MutationZrm_UpdateConversationStatusV2Args = {
  conversationId: Scalars['String']['input'];
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  lastReadMs?: InputMaybe<Scalars['String']['input']>;
  reportReasonType?: InputMaybe<ReportConversationReason>;
  userReportComment?: InputMaybe<Scalars['String']['input']>;
};

export type MutationZrm_UpdateNoteArgs = {
  conversationId: Scalars['String']['input'];
  note: Scalars['String']['input'];
};

export type Rh_AttachmentToBeDeletedArg = {
  messageId: Scalars['String']['input'];
  zDocId: Scalars['String']['input'];
};

export type Rh_SuccessStatusResponse = {
  __typename?: 'RH_SuccessStatusResponse';
  success: Scalars['Boolean']['output'];
};

export type Rh_RequestToApplyResponse = {
  __typename?: 'RH_RequestToApplyResponse';
  status?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum ReportConversationReason {
  DiscriminatoryOrAbusive = 'DISCRIMINATORY_OR_ABUSIVE',
  NotReported = 'NOT_REPORTED',
  Other = 'OTHER',
  Spam = 'SPAM',
}

export type SavedReplyArg = {
  reply: Scalars['String']['input'];
  replyIndex: Scalars['Int']['input'];
  title: Scalars['String']['input'];
};

export type Zrm_AddSystemMessageToConversationResponse = {
  __typename?: 'ZRM_addSystemMessageToConversationResponse';
  brandName?: Maybe<Scalars['String']['output']>;
  conversationId: Scalars['String']['output'];
  dateSentMs: Scalars['String']['output'];
  listingAlias: Scalars['String']['output'];
  message: Scalars['String']['output'];
  messageId: Scalars['String']['output'];
  messageType?: Maybe<Scalars['String']['output']>;
  referenceId?: Maybe<Scalars['String']['output']>;
  referenceIdType?: Maybe<Scalars['String']['output']>;
  senderName?: Maybe<Scalars['String']['output']>;
};

export type Zrm_SuccessStatusResponse = {
  __typename?: 'ZRM_SuccessStatusResponse';
  success: Scalars['Boolean']['output'];
};

export type Zrm_AttachmentToBeDeletedArg = {
  messageId: Scalars['String']['input'];
  zDocId: Scalars['String']['input'];
};

export type Zrm_InviteResponse = {
  __typename?: 'ZRM_InviteResponse';
  response: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type Zrm_ConversationCountsResponse = {
  __typename?: 'ZRM_ConversationCountsResponse';
  conversationCount?: Maybe<Scalars['Int']['output']>;
  lastMessageDateMs?: Maybe<Scalars['String']['output']>;
  listingConversationCount?: Maybe<Scalars['Int']['output']>;
  listingCounts: Array<Zrm_ListingCount>;
  unreadConversationCount?: Maybe<Scalars['Int']['output']>;
  unreadMessageCount?: Maybe<Scalars['Int']['output']>;
};

export type Zrm_ListingCount = {
  __typename?: 'ZRM_ListingCount';
  address: Scalars['String']['output'];
  conversationCount?: Maybe<Scalars['Int']['output']>;
  feedId: Scalars['String']['output'];
  feedListingId: Scalars['String']['output'];
  unreadConversationCount?: Maybe<Scalars['Int']['output']>;
  unreadMessageCount?: Maybe<Scalars['Int']['output']>;
};

export type Zrm_Listing = {
  __typename?: 'ZRM_Listing';
  city?: Maybe<Scalars['String']['output']>;
  listingAlias?: Maybe<Scalars['String']['output']>;
  listingId?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type Zrm_SatelliteWebCheckInfo = {
  __typename?: 'ZRM_satelliteWebCheckInfo';
  buildNumber?: Maybe<Scalars['Int']['output']>;
  host?: Maybe<Scalars['String']['output']>;
  nodeEnv?: Maybe<Scalars['String']['output']>;
  zgApi?: Maybe<Scalars['String']['output']>;
};
